import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
var _excluded = ["href", "text", "type", "onClick"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import React, { useContext } from 'react';
import { signInRioLog, clickBaseEvent } from '@chegg-me-components/utils';
import { rioClient } from '../../rio';
import { HeaderContext, useElementRectInfo } from '../../shared';
import { VisuallyHidden } from '../../styles/root';
import { NavWrap, NavLink, NavItem } from '../../styles/secondaryNav';
import { SecondaryNavLinkTypes } from '../../types/root';

var onNavItemClickRio = function onNavItemClickRio(_ref) {
  var type = _ref.type,
      isMobile = _ref.isMobile,
      text = _ref.text;
  // Rio Start
  var name = '';

  switch (type) {
    case SecondaryNavLinkTypes.SIGN_IN:
      signInRioLog();
      break;

    case SecondaryNavLinkTypes.FOR_EDUCATOR:
      name = 'nav educators shortcut';
      break;

    case SecondaryNavLinkTypes.HELP:
      name = 'nav help shortcut';
      break;
  }

  if (name) {
    rioClient.sendEvent(_objectSpread(_objectSpread({}, clickBaseEvent), {}, {
      data: {
        interaction: {
          element: {
            name: name,
            type: 'link',
            region_name: isMobile ? 'side nav' : 'top nav',
            text: text
          },
          type: isMobile ? 'tap' : 'click'
        }
      }
    }));
  } // Rio Finished

};

var SecondaryNav = function SecondaryNav(_ref2) {
  var secondaryNavLinks = _ref2.secondaryNavLinks,
      activeLink = _ref2.activeLink,
      _ref2$isMobile = _ref2.isMobile,
      isMobile = _ref2$isMobile === void 0 ? false : _ref2$isMobile;

  var _useContext = useContext(HeaderContext),
      envUrl = _useContext.envUrl,
      dataTestPrefix = _useContext.dataTestPrefix;

  return /*#__PURE__*/React.createElement(NavWrap, {
    "data-test": "".concat(dataTestPrefix, "-secondaryNav-wrap")
  }, secondaryNavLinks.map(function (_ref3, index) {
    var href = _ref3.href,
        text = _ref3.text,
        type = _ref3.type,
        _onClick = _ref3.onClick,
        rest = _objectWithoutProperties(_ref3, _excluded);

    var _useElementRectInfo = useElementRectInfo(),
        rectInfo = _useElementRectInfo.rectInfo,
        elementRef = _useElementRectInfo.elementRef;

    var isActive = (activeLink === null || activeLink === void 0 ? void 0 : activeLink.parent) === text;
    return /*#__PURE__*/React.createElement(NavItem, {
      key: index
    }, /*#__PURE__*/React.createElement(NavLink, _extends({
      redirect: type === SecondaryNavLinkTypes.SIGN_IN,
      href: "".concat(envUrl).concat(href),
      "data-test": "".concat(dataTestPrefix, "-secondaryNav-link-").concat(index),
      onClick: function onClick(e) {
        onNavItemClickRio({
          type: type,
          isMobile: isMobile,
          text: text
        });
        _onClick === null || _onClick === void 0 ? void 0 : _onClick(e);
      },
      isActive: isActive,
      ref: elementRef,
      positionX: rectInfo === null || rectInfo === void 0 ? void 0 : rectInfo.x
    }, rest), isActive && /*#__PURE__*/React.createElement(VisuallyHidden, {
      "data-test": "".concat(dataTestPrefix, "-secondaryNav-link-current-item-").concat(index)
    }, "Current page:", ' '), text));
  }));
};

SecondaryNav.displayName = 'SecondaryNav';
export default SecondaryNav;